<template>
  <div class="form-group select-wrapper token-input mt-0 mb-0">
    <div class="!tw-flex !tw-items-center">
      <UiTextarea
        ref="input"
        :placeholder="placeholder"
        :model-value="modelValue"
        :is-error="error"
        :autosize="{ minRows: 1, maxRows: 6}"
        @update:model-value="handleInput"
      />
      <div
        ref="button"
        class="add-token-btn text-green ml-8"
        @click="showTokens = !showTokens"
      >
        <UiIcon
          name="plus"
          :size="10"
          class="text-green mr-2"
        />
        {{ $t('postbacks.postback.addToken') }}
      </div>
    </div>
    <div
      v-if="showTokens"
      v-click-outside="blur"
      class="el-tag__wrap"
    >
      <span
        v-for="({ name, token, }) in tokens"
        :key="token"
        :class="{'el-tag--selected': isSelected(token)}"
        @click="select(token)"
      >
        <ElTag
          :closable="false"
          :close-transition="false"
          size="small"
          type="primary"
        >+ {{ name }}</ElTag>
      </span>
    </div>
  </div>
</template>

<script>

const CURRENCY_PART = 'CURRENCY_CODE';

export default {
  name: 'TokenInput',
  props: ['id', 'modelValue', 'placeholder', 'tokens', 'rows', 'multiline', 'error'],
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      showTokens: false,
    };
  },
  computed: {
    currencyCode() {
      return this.$store.state.payments.wallets.find((wallet) => wallet.status === 'active')?.currency_code || '';
    },
  },
  methods: {
    isSelected(token) {
      return (this.modelValue || '').includes(token.replace(`${CURRENCY_PART}}`, ''));
    },
    select(token) {
      if (this.isSelected(token)) {
        const matched = token.match(/{(\w+):\w+}/);
        const stringToSplit = matched ? new RegExp(`{${matched[1]}:\\w+}`) : token;
        this.$emit('update:modelValue', this.modelValue.split(stringToSplit).join(''));

      } else {
        const value = this.modelValue || '';
        const input = this.$refs.input.$el ? this.$refs.input.$el.getElementsByTagName('textarea')[0] : this.$refs.input;
        const begin = value.substring(0, input.selectionStart);
        const end = value.substring(input.selectionStart);
        this.$emit('update:modelValue', `${begin}${token.replace(CURRENCY_PART, this.currencyCode)}${end}`);
      }
    },
    handleInput(value) {
      this.$emit('update:modelValue', value);
    },
    blur(e) {
      const input = this.$refs.input.$el ? this.$refs.input.$el.children[0] : this.$refs.input;
      const button = this.$refs.button.$el ? this.$refs.button.$el.children[0] : this.$refs.button;

      if (e.toElement !== input && e.toElement !== button) {
        this.showTokens = false;
      }
    },
  },
};
</script>

<style lang="scss">
  // дубликатов нет
  @import 'src/assets/theme/default/components/tokenInput';
</style>
